/**
 * Shared mood options used across the application
 * Used in: home.js, creativeSpace.js, and mood tracking features
 */
export const MOOD_OPTIONS = [
    { value: "Happy", color: "#FFD93D", description: "Feeling joyful and content" },
    { value: "Calm", color: "#A8E6CF", description: "Peaceful and relaxed state of mind" },
    { value: "Energetic", color: "#FF6B6B", description: "Full of energy and vitality" },
    { value: "Tired", color: "#C7CEEA", description: "Feeling low energy and needing rest" },
    { value: "Emotional", color: "#FFB5E8", description: "Experiencing heightened emotions" },
    { value: "Anxious", color: "#B5B5B5", description: "Feeling worried or nervous" },
    { value: "Irritable", color: "#FFC078", description: "Easily annoyed or frustrated" },
    { value: "Content", color: "#B4E7CE", description: "Satisfied and at ease" }
];

/**
 * Get mood color by mood value
 * @param {string} mood - The mood value
 * @returns {string} - The color hex code
 */
export const getMoodColor = (mood) => {
    const moodOption = MOOD_OPTIONS.find(m => m.value === mood);
    return moodOption ? moodOption.color : "#B5B5B5";
};

/**
 * Greetings for dashboard welcome messages
 */
export const WELCOME_GREETINGS = [
    "Welcome back, {name}! Your love story continues here!",
    "Hey {name}! Good to have you here again!",
    "Hi {name}! Hope you're feeling close today!",
    "Hello {name}! One step closer every time!",
    "Nice to see you again, {name}!",
    "Hi {name}! This space keeps you connected!",
    "Hello {name}! Together is just a click away!",
    "Welcome, {name}! Let's keep the connection going!",
    "Hey {name}! Glad you're back!",
    "Hi {name}! Distance doesn't stop us!"
];

/**
 * Get time-based greeting
 * @param {string} name - User's name
 * @returns {string} - Appropriate greeting based on time of day
 */
export const getTimeBasedGreeting = (name) => {
    const hour = new Date().getHours();
    if (hour < 12) return `Good morning, ${name}!`;
    if (hour < 18) return `Good afternoon, ${name}!`;
    return `Good evening, ${name}!`;
};

/**
 * Get a random greeting or time-based greeting
 * @param {string} name - User's name
 * @returns {string} - A greeting message
 */
export const getWelcomeGreeting = (name) => {
    const useTimeBasedGreeting = Math.random() < 0.3;
    
    if (useTimeBasedGreeting) {
        return getTimeBasedGreeting(name);
    }
    
    const randomIndex = Math.floor(Math.random() * WELCOME_GREETINGS.length);
    return WELCOME_GREETINGS[randomIndex].replace('{name}', name);
};
